import * as S from './styled'
import GoldLang from '@/components/gold/GoldLang'

/** 저작권 상호명 — env(REACT_APP_COPYRIGHT) 주입, 미설정 빌드는 BRAND. */
const COPYRIGHT_NAME = process.env.REACT_APP_COPYRIGHT || process.env.REACT_APP_BRAND || ''

/**
 * ver2(gold) 하단 — gold8.bet PC: 어두운 띠, 왼쪽 저작권 문구, 오른쪽 언어 상자.
 */
export default function Footer() {
  return (
    <S.FooterRoot>
      <S.Inner>
        <S.Copy>
          ©{new Date().getFullYear()} {COPYRIGHT_NAME ? `${COPYRIGHT_NAME} ` : ''}ALL RIGHTS RESERVED
        </S.Copy>
        <GoldLang />
      </S.Inner>
    </S.FooterRoot>
  )
}
